import { styled } from "styled-components";

const PartnersSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 60px;
  gap: 40px;
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  box-sizing: border-box;

  @media (max-width: 767px) {
    padding: 30px 20px;
  }
`;

const PartnersTitle = styled.h2`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 40px;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;

  @media (max-width: 767px) {
    font-size: 28px;
  }
`;

const PartnersGrid = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 80px;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    gap: 40px;
  }
`;

const PartnerLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;

  img {
    max-width: 200px;
    max-height: 100%;
    object-fit: contain;
    filter: grayscale(0);
    opacity: 0.7;
    transition: all 0.3s ease;

    &:hover {
      opacity: 1;
      transform: scale(1.05);
    }
  }

  @media (max-width: 767px) {
    height: 80px;

    img {
      max-width: 150px;
    }
  }
`;

interface PartnersProps {
  logos: string[];
}

const PartnersContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  max-width: 1320px;
`;

const Partners = ({ logos }: PartnersProps) => {
  return (
    <PartnersSection>
      <PartnersContent>
        <PartnersTitle>Partneři aukcí</PartnersTitle>
        <PartnersGrid>
          {logos.map((logo, index) => (
            <PartnerLogo key={index}>
              <img src={logo} alt={`Partner ${index + 1}`} />
            </PartnerLogo>
          ))}
        </PartnersGrid>
      </PartnersContent>
    </PartnersSection>
  );
};

export default Partners;
